import * as tslib_1 from "tslib";
import _ from 'lodash';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
var isMobile = function (formFactor) { return formFactor === "Mobile" /* Mobile */; };
export var WidgetAreaEnum;
(function (WidgetAreaEnum) {
    WidgetAreaEnum["CONTENT"] = "content";
    WidgetAreaEnum["VISUAL"] = "visual";
    WidgetAreaEnum["ALL"] = "all";
})(WidgetAreaEnum || (WidgetAreaEnum = {}));
export var WidgetActionEnum;
(function (WidgetActionEnum) {
    WidgetActionEnum["NAVIGATE"] = "navigate";
    WidgetActionEnum["ADDTOCART"] = "addToCart";
})(WidgetActionEnum || (WidgetActionEnum = {}));
export var ImageScaling;
(function (ImageScaling) {
    ImageScaling["CROP"] = "crop";
    ImageScaling["FIT"] = "fit";
})(ImageScaling || (ImageScaling = {}));
export var WidgetDirectionEnum;
(function (WidgetDirectionEnum) {
    WidgetDirectionEnum["LEFT"] = "left";
    WidgetDirectionEnum["RIGHT"] = "right";
})(WidgetDirectionEnum || (WidgetDirectionEnum = {}));
export var WidgetAlignmentEnum;
(function (WidgetAlignmentEnum) {
    WidgetAlignmentEnum["LEFT"] = "left";
    WidgetAlignmentEnum["CENTER"] = "center";
    WidgetAlignmentEnum["RIGHT"] = "right";
})(WidgetAlignmentEnum || (WidgetAlignmentEnum = {}));
export var WidgetPresetIdEnum;
(function (WidgetPresetIdEnum) {
    WidgetPresetIdEnum["VERTICAL"] = "Wix_Store_Product_Widget_Vertical";
    WidgetPresetIdEnum["HORIZONTAL"] = "Wix_Store_Product_Widget_Horizontal";
})(WidgetPresetIdEnum || (WidgetPresetIdEnum = {}));
export var createTextParam = function (value) { return ({
    value: value,
    fontStyleParam: false,
}); };
export var getDefaultStyleParams = function (settings) { return ({
    booleans: {
        titleToggle: true,
        priceToggle: true,
        separatorToggle: settings.orientation === WidgetPresetIdEnum.HORIZONTAL,
        extendOnHoverToggle: true,
        extendOnHolidayToggle: false,
        extendFullImageOnHoverToggle: false,
        hoverButtonToggle: !settings.isMobile && settings.orientation === WidgetPresetIdEnum.VERTICAL,
        widgetButtonToggle: !(settings.isMobile && settings.orientation === WidgetPresetIdEnum.VERTICAL),
    },
    numbers: {
        hoverBackgroundColorOpacity: 0,
        hoverBorderSize: 0,
        actionButton_borderSize: 0,
        actionButton_cornersRadius: 0,
    },
    fonts: {
        imageScaling: createTextParam(ImageScaling.CROP),
        widgetAction: createTextParam(WidgetActionEnum.NAVIGATE),
        layout: createTextParam(''),
        alignment: createTextParam(settings.orientation === WidgetPresetIdEnum.HORIZONTAL ? WidgetAlignmentEnum.CENTER : WidgetAlignmentEnum.LEFT),
        widgetDirection: createTextParam(WidgetDirectionEnum.LEFT),
        hoverArea: createTextParam(WidgetAreaEnum.CONTENT),
        hoverBorderArea: createTextParam(WidgetAreaEnum.CONTENT),
        hoverButtonArea: createTextParam(WidgetAreaEnum.CONTENT),
        visualWidth: createTextParam('50%'),
        hoverState: createTextParam('zoom'),
    },
}); };
export function getRuntimeStyleParams(styleParams, _a) {
    var formFactor = _a.formFactor, widgetPreset = _a.widgetPreset;
    var result = getStyleParamsWithDefaults(styleParams, function () { return ({
        defaults: getDefaultStyleParams({ isMobile: isMobile(formFactor), orientation: widgetPreset }),
    }); });
    var mobile = {};
    if (isMobile(formFactor)) {
        mobile = {
        // booleans: {
        //   widgetButtonToggle: false,
        // },
        };
    }
    return _.merge({}, result, mobile);
}
var textKeys = [
    'alignment',
    'widgetAction',
    'imageScaling',
    'widgetDirection',
    'hoverArea',
    'hoverBorderArea',
    'hoverButtonArea',
    'hoverState',
];
var extractParams = function (styleParams) {
    var fonts = {};
    textKeys.forEach(function (key) {
        if (styleParams.fonts[key]) {
            fonts[key] = styleParams.fonts[key].value;
        }
    });
    return {
        fonts: fonts,
    };
};
export function getProductWidgetSettings(styleParams) {
    var _a = styleParams.numbers, hoverBackgroundColorOpacity = _a.hoverBackgroundColorOpacity, hoverBorderSize = _a.hoverBorderSize, actionButton_cornersRadius = _a.actionButton_cornersRadius, _b = styleParams.booleans, widgetButtonToggle = _b.widgetButtonToggle, titleToggle = _b.titleToggle, fullWidth = _b.full_width, priceToggle = _b.priceToggle, separatorToggle = _b.separatorToggle, hoverButtonToggle = _b.hoverButtonToggle, extendOnHoverToggle = _b.extendOnHoverToggle, extendOnHolidayToggle = _b.extendOnHolidayToggle, extendFullImageOnHoverToggle = _b.extendFullImageOnHoverToggle;
    var fontParams = extractParams(styleParams).fonts;
    return tslib_1.__assign({}, fontParams, { fullWidth: fullWidth,
        hoverBackgroundColorOpacity: hoverBackgroundColorOpacity,
        hoverBorderSize: hoverBorderSize,
        actionButton_cornersRadius: actionButton_cornersRadius,
        widgetButtonToggle: widgetButtonToggle,
        titleToggle: titleToggle,
        priceToggle: priceToggle,
        separatorToggle: separatorToggle,
        hoverButtonToggle: hoverButtonToggle,
        extendOnHoverToggle: extendOnHoverToggle,
        extendOnHolidayToggle: extendOnHolidayToggle,
        extendFullImageOnHoverToggle: extendFullImageOnHoverToggle });
}
export function getProductWidgetSettingsFromProps(props) {
    return getProductWidgetSettings(props.globals.style.styleParams);
}
//# sourceMappingURL=styleParamsService.js.map